// extracted by mini-css-extract-plugin
module.exports = {"Component":"StepRoomInformation_Component__2CbHo","FormAction":"StepRoomInformation_FormAction__2OIUC"};